<template>
    <div class="com-codics-hbb-order-admin-custom-body">
        <div class="com-codics-hbb-order-admin-custom-bar-content">
            <el-select class="com-codics-hbb-order-admin-custom-bar-input" v-model="userId" clearable filterable remote
                reserve-keyword placeholder="请选择销售" :remote-method="queryUsersFuc" :loading="loading"
                @change="listCusInfo2Fuc">
                <el-option v-for="(item, index) in userData" :key="index" :label="`${item.nickname}(${item.account})`"
                    :value="item.id">
                </el-option>
            </el-select>
            <el-input class="com-codics-hbb-order-admin-user-bar-input" v-model="searchTxt" style="margin-left: 15px;"
                placeholder="请输入账号/昵称/邮箱/手机号..." clearable @input="searchChange">
            </el-input>
            <MyButton style="float: left;margin-left: 15px;padding:0 15px;"
                @click.native="nowSearchTxt = searchTxt; listCusInfo2Fuc();">&#xe86e;
            </MyButton>
            <MyButton style="float: right;" @click.native="addVisible = true">&#xe632; 添加客户</MyButton>
            <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info" icon-color="red"
                title="您确定要删除选中的用户数据吗？" @confirm="deleteCusInfosFuc">
                <MyButton style="float: right;margin-right: 15px;padding:0 15px;" slot="reference">&#xe850;</MyButton>
            </el-popconfirm>
        </div>
        <div class="com-codics-hbb-order-admin-custom-bar-content com-codics-hbb-order-admin-custom-bar-content2"
            style="margin-top: 10px;">
            <el-table :data="searchTxt == '' ? tableData : searchData" style="width: 100%;transition: .3s;"
                @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="50" :selectable="row => row.member !== 0">
                </el-table-column>
                <el-table-column prop="id" label="ID" width="80">
                </el-table-column>
                <el-table-column prop="pid" label="负责销售" width="80">
                    <template slot-scope="scope">
                        {{ scope.row.pid == 0 ? '公海客户' : scope.row.account?.nickname }}
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="姓名" width="160">
                </el-table-column>
                <el-table-column prop="phone" label="联系方式" width="120">
                </el-table-column>
                <el-table-column prop="com" label="所属公司" width="120">
                </el-table-column>
                <el-table-column prop="area" label="地址信息" width="180">
                </el-table-column>
                <el-table-column prop="country" label="国家" width="120">
                </el-table-column>
                <el-table-column prop="religion" label="宗教信仰" width="90">
                </el-table-column>
                <el-table-column prop="email" label="邮箱" width="120">
                </el-table-column>
                <el-table-column prop="rating" label="客户评级" width="90">
                    <template slot-scope="scope">
                        {{ ['优质客户', '高级客户', '中级客户', '低级客户', '垃圾客户'][scope.row.rating] }}
                    </template>
                </el-table-column>
                <el-table-column prop="srce" label="客户来源" width="90">
                    <template slot-scope="scope">
                        {{ ['阿里巴巴', '中国制造', '独立站', '公司展会', '集团客户', '亚马逊', '脸书', '广交会', '环球资源', '社交媒体', '速卖通',
                            '其他来源'][scope.row.srce] }}
                    </template>
                </el-table-column>
                <el-table-column prop="createtime" label="注册时间" width="260">
                    <template slot-scope="scope">
                        {{ initTime(scope.row.ctime) }}
                    </template>
                </el-table-column>
                <el-table-column align="right" label="操作" min-width="150">
                    <template slot-scope="scope">
                        <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info"
                            icon-color="red" title="您确定要删除当前客户数据吗？" @confirm="deleteCusInfosFuc([scope.row.id])">
                            <MyButton v-show="scope.row.member != 0" size="small" type="danger" style="float: right;"
                                slot="reference">删除</MyButton>
                        </el-popconfirm>
                        <MyButton v-show="userInfo?.user?.member == 0 && scope.row.pid === 0" size="small" type="danger"
                            @click.native="nowId2 = scope.row.id; fpVisible = true;"
                            style="float: right;margin-right: 10px;">分配</MyButton>
                        <MyButton size="small" type="danger" @click.native="jumpToShop(scope.row)"
                            style="float: right;margin-right: 10px;">
                            采购</MyButton>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="codics-aonaer-info-sys-news-pagination" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
                :page-sizes="[10, 20, 30, 40]" :page-size="searchTxt == '' ? dataSize : searchSize"
                layout="total, sizes, prev, pager, next, jumper, slot" :total="searchTxt == '' ? maxSize : searchMax">
            </el-pagination>
        </div>
        <RegisterDialog v-model="registerDialog"></RegisterDialog>
        <RegisterDialog2 v-model="registerDialog2"></RegisterDialog2>
        <MyDialog :visible.sync="addVisible" title="新建客户" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:calc(50% - 7.5px);" label="客户名称" required>
                    <el-input v-model="addForm.name" size="small" placeholder="请输入客户名称" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem style="width:calc(50% - 7.5px);margin-left: 15px;" label="联系方式" required>
                    <el-input v-model="addForm.phone" size="small" placeholder="请输入客户联系方式" maxLength="11"
                        style="width:100%;" clearable></el-input>
                </MyFormItem>
                <MyFormItem style="width:calc(50% - 7.5px);" label="邮箱">
                    <el-input v-model="addForm.email" size="small" placeholder="请输入客户邮箱" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem style="width:calc(50% - 7.5px);margin-left: 15px;" label="所属公司">
                    <el-input v-model="addForm.com" size="small" placeholder="请输入客户所属公司" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem label="客户地址" style="width:calc(50% - 7.5px);">
                    <el-input v-model="addForm.area" size="small" placeholder="请输入客户地址信息" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem label="所属国家" style="width:calc(50% - 7.5px);margin-left: 15px;">
                    <el-cascader style="width:100%;" :props="{ checkStrictly: true }" size="small" filterable
                        :options="areaOptions" v-model="addForm.country" clearable>
                    </el-cascader>
                </MyFormItem>
                <MyFormItem label="宗教信息" style="width:calc(50% - 7.5px);">
                    <el-input v-model="addForm.religion" size="small" placeholder="请输入客户宗教信息" style="width:100%;"
                        clearable></el-input>
                </MyFormItem>
                <MyFormItem label="客户评级" style="width:calc(50% - 7.5px);margin-left: 15px;" required>
                    <el-select v-model="addForm.rating" style="width:100%;" filterable size="small"
                        placeholder="请选择客户评级">
                        <el-option v-for="(item, index) in ['优质客户', '高级客户', '中级客户', '低级客户', '垃圾客户']" :key="index"
                            :label="item" :value="index">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <MyFormItem label="客户来源" style="width:calc(50% - 7.5px);" required>
                    <el-select v-model="addForm.srce" style="width:100%;" filterable size="small" placeholder="请选择客户来源">
                        <el-option
                            v-for="(item, index) in ['阿里巴巴', '中国制造', '独立站', '公司展会', '集团客户', '亚马逊', '脸书', '广交会', '环球资源', '社交媒体', '速卖通', '其他来源']"
                            :key="index" :label="item" :value="index">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <MyFormItem style="width:calc(50% - 7.5px);margin-left: 15px;" label="客户类型" required>
                    <el-select v-model="addForm.pid" style="width:100%;" filterable size="small" placeholder="请选择客户类型">
                        <el-option v-for="(item, index) in [{
                            label: '个人客户',
                            value: 0
                        }, {
                            label: '公海客户',
                            value: 1
                        }]" :key="index" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain
                    @click="addCusInfoFuc">确认创建</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="addVisible = false;">取消创建</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="fpVisible" title="分配销售" :width="'950px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 5px;padding: 0 5px;">
                <MyFormItem style="width:calc(50% - 7.5px);" label="负责销售" required>
                    <el-select style="width:100%;" size="small" v-model="nowXs" clearable filterable remote
                        reserve-keyword placeholder="请选择销售" :remote-method="queryUsersFuc" :loading="loading">
                        <el-option v-for="(item, index) in userData" :key="index"
                            :label="`${item.nickname}(${item.account})`" :value="item.id">
                        </el-option>
                    </el-select>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:60px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="fpXsFuc">确认分配</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="fpVisible = false;">取消分配</el-button>
            </div>
        </MyDialog>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import areaData from '@/../public/data/data2.json';
import dayjs from 'dayjs';
import MyForm from '@/components/MyForm';
import MyFormItem from '@/components/MyForm/MyFormItem';
import MyButton from '@/components/MyButton';
import MyDialog from '@/components/MyDialog';
import RegisterDialog from '@/components/RegisterDialog';
import RegisterDialog2 from '@/components/RegisterDialog2';
import { jumpTo } from '@/utils/myutils';
import { listUsers, deleteUsers, repassUsers, listRole, userRole, listCusInfo2, queryUsers, deleteCusInfo, addCusInfo, fpXs } from '@/api';
export default {
    data() {
        return {
            nowXs: null,
            fpVisible: false,
            areaOptions: areaData,
            addVisible: false,
            userId: null,
            nowId: null,
            nowId2: null,
            nowRole: [],
            roleDialog: false,
            registerDialog: false,
            registerDialog2: false,
            tableData: [],
            searchData: [],
            selectData: [],
            roleData: [],
            memsList: [],
            userData: [],
            searchTxt: '',
            nowSearchTxt: '',
            currentPage: 1,
            searchPage: 1,
            dataSize: 10,
            searchSize: 10,
            maxSize: 0,
            searchMax: 0,
            loading: false,
            addForm: {
                pid: 0,
                com: '',
                area: '',
                name: '',
                phone: '',
                email: '',
                country: '',
                religion: '',
                rating: 0,
                srce: 0
            }
        }
    },
    components: {
        MyButton,
        MyDialog,
        RegisterDialog,
        RegisterDialog2,
        MyForm,
        MyFormItem
    },
    mounted() {
        this.listCusInfo2Fuc();
    },
    methods: {
        jumpToShop(row) {
            window.ceshiProduct = row;
            jumpTo(this, "产品商城", {}, { id: row.id });
        },
        async fpXsFuc() {
            if (this.nowXs === null || this.nowXs === '') {
                this.$message.error('请选择销售！');
                return;
            }
            if (this.nowId2 === null || this.nowId2 === '') {
                this.$message.error('请选择客户！');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await fpXs({
                id: this.nowId2,
                uid: this.nowXs
            });
            loading.close();
            if (data.code == 200) {
                this.$message.success('客户分配成功！');
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                if (data.code == 401) return;
                this.$message.error(data.message);
            }
        },
        async addCusInfoFuc() {
            if (this.addForm.name == null || this.addForm.name == '') {
                this.$message.error('请输入客户名称！');
                return;
            }
            if (this.addForm.phone == null || this.addForm.phone == '' || this.addForm.phone.length != 11) {
                this.$message.error('客户联系方式未填写或格式不正确！');
                return;
            }
            if (this.addForm.pid === null || this.addForm.pid === '') {
                this.$message.error('请选择客户类型！');
                return;
            }
            if (this.addForm.email !== null && this.addForm.email !== '') {
                if (!/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/.test(this.addForm.email)) {
                    this.$message.error('请输入正确的邮箱格式！');
                    return;
                }
            }
            if (this.addForm.rating === null || this.addForm.rating === '') {
                this.$message.error('请选择客户评级！');
                return;
            }
            if (this.addForm.srce === null || this.addForm.srce === '') {
                this.$message.error('请选择客户来源！');
                return;
            }
            this.addForm.country && (this.addForm.country = this.addForm.country.join('/'));
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await addCusInfo(this.addForm);
            loading.close();
            if (data.code == 200) {
                this.$message.success('客户创建成功！');
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            } else {
                if (data.code == 401) return;
                this.$message.error(data.message);
            }
        },
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        },
        async listCusInfo2Fuc() {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await listCusInfo2({
                key: this.nowSearchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                uid: this.userId || 0
            });
            loading.close();
            if (data.code == 200) {

                if (this.searchTxt == '') {

                    this.tableData = data.data;

                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.count;

                }

            } else {
                if (data.code == 401) return;
                this.$message.error(data.message);
            }
        },
        async userRoleFuc() {
            if (this.nowId == null || this.nowId == '') {
                this.$message.error('请先选择要修改的用户！');
                return;
            }
            if (this.nowRole.length == 0) {
                this.$message.error('请选择用户角色！');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await userRole({
                id: this.nowId,
                role: this.nowRole[this.nowRole.length - 1]
            });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '修改成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        roleChange() {

            if (this.nowSearchTxt == '') {

                this.currentPage = 1;

                this.dataSize = 10;

                this.tableData = [];

                this.listUsersFuc();

            } else {

                this.searchPage = 1;

                this.searchSize = 10;

                this.searchData = [];

                this.listUsersFuc();

            }

        },
        async listRoleFuc() {

            const data = await listRole();

            if (data.code == 200) {

                this.roleData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        addUserCommand(a) {
            switch (a) {
                case '直接创建':
                    this.registerDialog2 = true;
                    break;
                case '邀请注册':
                    this.registerDialog = true;
                    break;
            }
        },
        searchUsers() {

            if (this.searchTxt == '') {

                this.$message.error('请先输入要搜索的内容！');

                return;

            }

            this.searchPage = 1;

            this.searchMax = 0;

            this.searchData = [];

            this.nowSearchTxt = this.searchTxt;

            this.listUsersFuc();

        },
        async queryUsersFuc(query) {

            if (query === '') {
                this.userData = [];
                return;
            }

            this.loading = true;

            const data = await queryUsers({
                key: query
            });

            this.loading = false;

            if (data.code == 200) {

                this.userData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async repassUsersFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要重置的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await repassUsers({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '共' + data.count + '条数据重置成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async deleteCusInfosFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteCusInfo({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        stateFilter(v, r, c) {

            return r.state === v;

        },
        memberFilter(v, r, c) {

            return r.member === v;

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.listUsersFuc();
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.listUsersFuc();
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        initTime(str) {
            return dayjs(str).format('YYYY-MM-DD HH:mm:ss');
        },
    },
    computed: {
        ...mapState(['userInfo']),
    }
}
</script>

<style>
.com-codics-hbb-order-admin-custom-body {
    height: fit-content;
    min-height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
}

.com-codics-hbb-order-admin-custom-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-hbb-order-admin-custom-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-hbb-order-admin-custom-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-hbb-order-admin-custom-bar-input {
    width: 300px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}
</style>